'use client';

import { PodcastType } from '@elsevier-health/osmosis-shared/types/podcast';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { H1 } from '@osmosis/tailwind-ui/components/Text';
import { P } from '@osmosis/tailwind-ui/components/Text';
import Image from 'next/image';
import React from 'react';
import PodcastSubscribe from './PodcastSubscribe';

type Props = {
  podcast: PodcastType;
};

/**
 * Podcast banner.
 * @param props
 * @returns
 */
const PodcastBanner = (props: Props) => {
  const { podcast } = props;

  return (
    <Box cn="bg-blue-100 p-8 rounded-lg border-blue-200 border-1">
      <Box cn="flex gap-8 sm:flex-row flex-col">
        <Box cn="sm:w-[240px] h-[240px] w-full relative">
          <Image
            src={podcast.image_url}
            fill={true}
            alt={`Podcast thumbnail`}
            className="rounded-lg object-contain"
          />
        </Box>

        <Box cn="flex flex-col gap-8 flex-1">
          <H1>{podcast.title}</H1>
          <P>{podcast.description}</P>

          <PodcastSubscribe podcast={podcast} />
        </Box>
      </Box>
    </Box>
  );
};

export default PodcastBanner;
